import type { OrganizationUnitType } from '../models/organization.model';

/**
 * Which organization units a station may be created on.
 *
 * The department, and nothing else — the customer's decision of 2026-10-30.
 * A station is a concrete place of work: a kitchen, a ward, a line. It
 * belongs to the department that runs it, not to the legal entity above it
 * and not to the profit centre its figures roll up into.
 *
 * It followed `canHoldPosition` until then — everything but the root — which
 * came from the day the station left the tree (2026-10-27) and was never a
 * decision of its own. It is one now.
 */
export function canHoldStation(type: OrganizationUnitType): boolean {
  return type === 'department';
}
